var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',[_c('header',{staticClass:"major"},[_c('p',[_vm._v(_vm._s(_vm.topword))]),_c('h2',[_vm._v(_vm._s(_vm.title))])]),_c('p',[_vm._v(" "+_vm._s(_vm.bodytext)+" ")]),_c('action',{attrs:{"buttons":_vm.buttons}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }